<template >
  <div class="container">
    <!-- Outer Row -->
    <div class="row justify-content-center">
      <div class="col-xl-10 col-lg-12 col-md-9">
        <div class="card o-hidden border-0 shadow-lg my-5">
          <div class="card-body p-0">
            <div class="row justify-content-center">
              <!-- <div class="col-lg-6 d-none d-lg-block"></div> -->
              <div class="col-lg-6 col-md-9 col-sm-12">
                <div class="p-5">
                  <div class="text-center">
                    <h1 class="h4 text-gray-900 mb-4">Selbeg.MN системд нэвтэрнэ үү!</h1>
                  </div>
                  <div class="user" autocomplete="off">
                    <div class="form-group">
                      <input type="text" v-model.trim="loginForm.phone" class="form-control form-control-user" placeholder="Утас">
                    </div>
                    <div class="form-group ">
                      
                      <input type ="password" v-model.trim="loginForm.password" class="form-control form-control-user" id="exampleInputPassword" placeholder="Нууц үг">
                    </div>
                    <div  v-if="loading==false">
                      <button @click="login" type="button" class="btn btn-success btn-block">
                        Нэвтрэх
                      </button>
                    </div>
                    <hr class="my-4"/>
                    <div  v-if="loading==false">
                      <button @click="teacherLogin" type="button" class="btn btn-google btn-block">
                        Aдмин
                      </button>
                    </div>
                    <button type="button" v-else class="btn btn-google btn-block" disabled>
                      <span class="spinner-border spinner-border-sm"></span>
                      Loading..
                    </button>
                    <br />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const fb = require("../../firebaseConfig.js");
export default {
  name: "Adminman",
  data() {
    return {
      loading:false,
      loginForm:{
        phone:null,
        password:null
      }
    };
  },
  methods: {
    teacherLogin() {
      this.loading=true;
      this.$router.push('/teacherlogin');
    },
    studentLogin(){
      this.loading=true;
      this.$router.push('/studentlogin');

    },
    login(){
      if(this.loginForm!=null && this.loginForm.phone!=null && this.loginForm.password!=null){
        this.loading = true
        fb.auth.signInWithEmailAndPassword(this.loginForm.phone+"@selbeg.mn", this.loginForm.password).then(user => {
            this.$store.commit('setCurrentUser', user.user)
            this.$store.dispatch('fetchUserProfile');
            this.$store.dispatch("setEnabledTrue");
            this.loading = false;
            this.$router.push('/hello');
        }).catch(err => {
          alert(err.message);
            // console.log(err);
            this.loading = false;
            this.errorMsg = err.message
        });
      }
    }
  }
};
</script>

